<script setup lang="ts">
import type { Payment } from 'pejer/src/tables/Payment';
import { computed } from 'vue';
import { cn, splitCamelCase } from '../lib/utils';

type StatusBadgeProps = Payment.PaymentStatus

const props = defineProps<{
  status: StatusBadgeProps
}>()

const statusClass: {
  [key in StatusBadgeProps]: string
} = {
  InitiatedPayment: 'inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 border border-gray-500/10',
  ReservedPayment: 'inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 border border-gray-500/10',

  RefundInitiated: 'inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 border border-blue-700/10',
  RefundedPayment: 'inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 border border-blue-700/10',

  CancelledPayment: 'inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 border border-red-600/10',
  FailedPayment: 'inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 border border-red-600/10',

  ChargedPayment: 'inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 border border-green-600/20',
  InvoiceConfirmed: 'inline-flex items-center rounded-md bg-indigo-50 px-2 py-1 text-xs font-medium text-indigo-700 border border-indigo-700/20',
}

const statusString = computed(() =>
  props.status ? splitCamelCase(props.status.replace('Payment', '')) : 'No payment'
)

const statusClassChosen = computed(() => statusClass[props.status ?? 'InitiatedPayment'])
</script>

<template>
  <span
    :class="cn('text-xs font-semibold text-center rounded-md badge px-4 w-min whitespace-nowrap', statusClassChosen)"
  >
    {{ statusString }}
  </span>
</template>
